<!--
 * @Author: ZS
 * @Date: 2020-06-09 16:55:43
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-08 11:59:07
 * @Description: file content
-->
<template>
  <!-- 侧边导航 -->
  <ul class="affix-toolbar">
    <!-- <li>
      <a href="javascript:;">
        <img src="../../assets/images/icon_kefu.png" alt="">
        <span>智能客服</span>
      </a>
    </li> -->
    <li v-if="false">
      <a href="javascript:;">
        <img src="../../assets/images/icon_jindu.png" alt="">
        <span>办理进度</span>
      </a>
    </li>
    <li>
      <el-popover placement="left" width="200" trigger="hover">
        <div style="text-align:center">
          <img src="../../assets/images/time1.png" alt="" style="widt:80px;height:80px">
          <p style="line-height:36px;color:#666666">即将上线敬请期待~</p>
        </div>
         <a href="javascript:;" slot="reference">
           <img src="../../assets/images/icon_phone.png" alt="">
           <span>移动端</span>
         </a>
      </el-popover>

    </li>
    <li class="ywtb_personal" @click="jumpTo()">
      <a href="javascript:;">
        <img src="../../assets/images/icon_wode.png" alt="">
        <span>我的</span>
      </a>
    </li>
    <li @click="backTop()">
      <a href="javascript:;">
        <img src="../../assets/images/icon_back.png" alt="">
        <span>返回顶部</span>
      </a>
    </li>
  </ul>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    mounted() {
      window.addEventListener("scroll", this.showbtn, true);
    },
    methods: {
      backTop() {
        var timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          this.isTop = true;
          if (osTop === 0) {
            clearInterval(timer);
          }
        }, 30)
      },
      showbtn() {
        let that = this;
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        that.scrollTop = scrollTop
      },
      jumpTo() {
        this.$router.push('/user')
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/ToolBar.vue